import { Box, Stack } from "@mui/material";
import { pdf, PDFViewer } from "@react-pdf/renderer";
import axios from "axios";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../lib/Context";
import { baseUrl } from "../../services";
import {
  getServiceAgrementById,
  resendServiceAgrement,
  updateServiceAgrement,
} from "../../services/AgrementApi";
import { handleOpenSnackBar } from "../../utils/helper";
import { serviceAgrementValidation } from "../../utils/Validation";
import AggrementPdf from "../aggrementPdf";
import GlobalButton from "../button";
import AppHeader from "../header";
import AppLoader from "../loader";
import KeyInformation from "./KeyInoformation";
import ServiceAgrementLogs from "./Logs";
import { resendConfirm } from "../alerts";
import { endPoints } from "../../lib/Variable";
import { getAccessToken } from "../../services/tokenStore";

const ServiceAgrement = () => {
  const { userData } = useContext(AppContext);
  const formErrorRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [inputError, setInputError] = useState({});
  const params = useParams();
  const navigate = useNavigate();
  const [inputValues, setInputValues] = useState({
    // businessName: "MH Enterprises",
    // tradingName: "MH Enterprises",
    // addressLine1: "123 Main St",
    // addressLine2: "Apt 1",
    // town: "New York",
    // county: "New York",
    // postcode: "10001",
    // country: "United States",
    // businessPhone: "07921234567",
    // yearsInBusiness: "10",
    // businessUrl: "https://www.mhenterprises.com",
    // email: "trusttelecom1997@gmail.com",
    // registrationNo: "1234567890",
    // vatNo: "1234567890",
    // contactName: "John Doe",
    // position: "CEO",
    // contactPhone: "07921234567",
    // installationAddress: "123 Main St, New York, NY 10001, United States",
    // minTerm: "12",
    // onSitePayment: "1000",
    // monthlyPayment: "100",
    // equipmentModel: "Model 1",
    // manufacturer: "Manufacturer 1",
    // quantity: "1",
    // bankName: "Bank of America",
    // nameOnAccount: "John Doe",
    // bankAccountNumber: "28780237",
    // bankSortCode: "040605",
    // bankPostCode: "10001",
    // bankAddress: "123 Main St, New York, NY 10001, United States",
    businessName: "",
    tradingName: "",
    addressLine1: "",
    addressLine2: "",
    town: "",
    county: "",
    postcode: "",
    country: "",
    businessPhone: "",
    yearsInBusiness: "",
    businessUrl: "",
    email: "",
    registrationNo: "",
    vatNo: "",
    contactName: "",
    position: "",
    contactPhone: "",
    installationAddress: "",
    minTerm: "",
    onSitePayment: "",
    monthlyPayment: "",
    equipmentModel: "",
    quantity: "",
    bankName: "",
    nameOnAccount: "",
    bankAccountNumber: "",
    bankSortCode: "",
    bankPostCode: "",
    bankAddress: "",
    isBankDetailsVerified: false,
    isInstallAddrSame: false,
  });

  const fetchServiceAgrementById = async (id) => {
    setIsLoading(true);
    try {
      const response = await getServiceAgrementById(id);
      if (response?.data.status === "success") {
        setInputValues(response?.data.data);
      }
    } catch (error) {
      console.error(error, "error");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (params?.id) {
      fetchServiceAgrementById(params?.id);
    }
  }, [params?.id]);

  const scrollToError = () => {
    if (formErrorRef.current) {
      formErrorRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
      setTimeout(() => {
        if (formErrorRef.current) {
          formErrorRef.current.focus();
        }
      }, 300);
    }
  };

  const handleSubmit = async () => {
    formErrorRef.current = null;

    const isValid = serviceAgrementValidation(
      inputValues,
      setInputError,
      formErrorRef,
    );
    if (!isValid) return scrollToError();

    if (!inputValues.isBankDetailsVerified) {
      return handleOpenSnackBar("error", "Bank details are not verified");
    }

    const token = getAccessToken();

    setIsLoading(true);

    try {
      // Create the PDF document
      const pdfDoc = <AggrementPdf inputValues={inputValues} />;
      const pdfBlob = await pdf(pdfDoc).toBlob();

      //  Initialize FormData and append the data
      const formData = new FormData();
      formData.append("pdf", pdfBlob, "service_agreement.pdf");
      formData.append("email", inputValues?.email);
      formData.append("businessName", inputValues?.businessName);
      formData.append("tradingName", inputValues?.tradingName);
      formData.append("addressLine1", inputValues?.addressLine1);
      formData.append("addressLine2", inputValues?.addressLine2);
      formData.append("town", inputValues?.town);
      formData.append("county", inputValues?.county);
      formData.append("postcode", inputValues?.postcode);
      formData.append("country", inputValues?.country);
      formData.append("businessPhone", inputValues?.businessPhone);
      formData.append("yearsInBusiness", inputValues?.yearsInBusiness);
      formData.append("businessUrl", inputValues?.businessUrl);
      formData.append("registrationNo", inputValues?.registrationNo);
      formData.append("vatNo", inputValues?.vatNo);
      formData.append("contactName", inputValues?.contactName);
      formData.append("position", inputValues?.position);
      formData.append("contactPhone", inputValues?.contactPhone);
      formData.append("installationAddress", inputValues?.installationAddress);
      formData.append("minTerm", inputValues?.minTerm);
      formData.append("onSitePayment", String(inputValues?.onSitePayment));
      formData.append("monthlyPayment", String(inputValues?.monthlyPayment));
      formData.append("equipmentModel", inputValues?.equipmentModel);
      formData.append("quantity", String(inputValues?.quantity));
      formData.append("nameOnAccount", inputValues?.nameOnAccount);
      formData.append("bankName", inputValues?.bankName);
      formData.append("bankAccountNumber", inputValues?.bankAccountNumber);
      formData.append("bankSortCode", inputValues?.bankSortCode);
      formData.append("bankPostCode", inputValues?.bankPostCode);
      formData.append("bankAddress", inputValues?.bankAddress);
      formData.append("createdBy", userData?._id);
      formData.append("isInstallAddrSame", inputValues?.isInstallAddrSame);

      // Send the FormData to the server
      const response = await axios.post(
        `${baseUrl}agreement/sendPdf`,
        formData,
        {
          timeout: 3000000,
          headers: {
            "Content-Type": "multipart/form-data",
            ...(token && {
              Authorization: `Bearer ${token}`,
            }),
          },
        },
      );

      if (response?.data?.status === "success") {
        handleOpenSnackBar("success", response?.data?.message);
        navigate("/service-agrement");
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditAgreement = async () => {
    formErrorRef.current = null;

    const isValid = serviceAgrementValidation(
      inputValues,
      setInputError,
      formErrorRef,
    );
    if (!isValid) return scrollToError();

    if (!inputValues.isBankDetailsVerified) {
      return handleOpenSnackBar("error", "Bank details are not verified");
    }

    const payload = {
      ...inputValues,
      _changedBy: userData?._id,
    };

    try {
      setIsLoading(true);
      const response = await updateServiceAgrement(params?.id, payload);
      if (response?.data?.status === "success") {
        handleOpenSnackBar("success", response?.data?.message);
        fetchServiceAgrementById(params?.id);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleResendAgreementConfirm = () => {
    formErrorRef.current = null;

    const isValid = serviceAgrementValidation(
      inputValues,
      setInputError,
      formErrorRef,
    );
    if (!isValid) return scrollToError();

    if (!inputValues.isBankDetailsVerified) {
      return handleOpenSnackBar("error", "Bank details are not verified");
    }

    resendConfirm({
      title: "Are you sure?",
      text: "This action will resend the agreement to the customer.",
      confirmText: "Yes, resend",
      onConfirm: handleResendAgreement,
    });
  };

  const handleResendAgreement = async () => {
    try {
      // Create the PDF document
      const pdfDoc = <AggrementPdf inputValues={inputValues} />;
      const pdfBlob = await pdf(pdfDoc).toBlob();

      // Initialize FormData and append the data
      const formData = new FormData();
      formData.append("pdf", pdfBlob, "service_agreement.pdf");

      const token = getAccessToken();

      setIsLoading(true);

      const response = await axios.patch(
        `${baseUrl}${endPoints.resendServiceAgrement.replace(":id", params?.id)}`,
        formData,
        {
          timeout: 3000000,
          headers: {
            "Content-Type": "multipart/form-data",
            ...(token && {
              Authorization: `Bearer ${token}`,
            }),
          },
        },
      );
      if (response?.data?.status === "success") {
        handleOpenSnackBar("success", response?.data?.message);
        fetchServiceAgrementById(params?.id);
      } else {
        handleOpenSnackBar("error", response?.data?.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AppHeader>
      <AppLoader isVisible={isLoading} />
      <KeyInformation
        inputValues={inputValues}
        setInputValues={setInputValues}
        inputError={inputError}
        setInputError={setInputError}
        id={params?.id}
      />

      <Stack
        mt={4}
        my={2}
        direction={"row"}
        justifyContent={"flex-end"}
        spacing={2}
      >
        {params?.type === "edit" && (
          <GlobalButton
            variant="custom_gradient"
            handleClickBtn={handleEditAgreement}
            title="Save Agreement"
            style={{ height: 50, borderRadius: "4px" }}
          />
        )}
        {params?.type === "add" && (
          <GlobalButton
            variant="custom_gradient"
            handleClickBtn={handleSubmit}
            title="Submit Agreement"
            style={{ height: 50, borderRadius: "4px" }}
          />
        )}
        {params?.type === "edit" && (
          <GlobalButton
            variant="custom_gradient"
            handleClickBtn={handleResendAgreementConfirm}
            title="Resend Agreement"
            style={{ height: 50, borderRadius: "4px" }}
          />
        )}
      </Stack>

      {params?.type !== "add" && (
        <ServiceAgrementLogs logs={inputValues?.logs} />
      )}

      {/* Showing PDF */}

      {/* <Box
        mt={4}
        width={"100%"}
        height={"100%"}
        sx={{ overflow: "auto", border: "1px solid #E0E0E0", borderRadius: 1 }}
      >
        <PDFViewer
          key={JSON.stringify(inputValues)}
          showToolbar={true}
          style={{ width: "100%", height: "800px" }}
        >
          <AggrementPdf inputValues={inputValues} />
        </PDFViewer>
      </Box> */}
    </AppHeader>
  );
};

export default ServiceAgrement;
